/*
 * @Author: zwt.daffy
 * @Date: 2019-09-19 14:10:21
 * @Last Modified by: chenjie
 * @Last Modified time: 2020-09-01 16:42:31
 */

import request from '@/api/base'

/** 工作流记录配置 */
const getUserName = (params) => {
  return request.post('/ipark-admin/flow/getUserName', params)
}
const pageFlowRecord = (params) => {
  return request.post('/ipark-admin/flow/pageFlowRecord', params)
}
const getFlowRecord = (params) => {
  return request.post('/ipark-admin/flow/getFlowRecord', params)
}
const addFlowRecord = (params) => {
  return request.post('/ipark-admin/flow/addFlowRecord', params)
}
const updateFlowRecord = (params) => {
  return request.post('/ipark-admin/flow/updateFlowRecord', params)
}
const openFlowRecord = (params) => {
  return request.post('/ipark-admin/flow/deployFlowRecord', params)
}
const delFlowRecord = (params) => {
  return request.post('/ipark-admin/flow/delFlowRecord', params)
}

/** ***** 工作流流程配置 */
// 创建工作流具体流程
const createProcess = (params) => {
  return request.post('/ipark-admin/flow/createProcess', params)
}
// 获取工作流具体流程
const getProcessByKey = (params) => {
  return request.post('/ipark-admin/flow/getProcessByKey', params)
  // return request.post('/ipark-admin/flow/getProcess', params)
}
const getProductProcess = (params) => { // 获取已发布的流程信息
  return request.post('/ipark-admin/flow/getProductProcess', params)
}
const getStatusList = (params) => {
  return request.post('/ipark-admin/flow/getCfgArray', params)
}
const selectFeedbackTypeList = (params) => {
  return request.post('/ipark-admin/feedback/selectFeedbackTypeList', params)
}
// 获取节点配置的人员\角色
const saveOrUpdateTaskUser = (params) => {
  return request.post('/ipark-admin/flow/saveOrUpdateTaskUser', params)
}
const getRoleList = (params) => {
  return request.post('/ipark-admin/flow/getRoleList', params)
}

const getTaskOperatorByCondition = (params) => {
  return request.post('/ipark-admin/flow/getTaskOperatorByCondition', params)
}
const saveOrUpdateTaskOperator = (params) => {
  return request.post('/ipark-admin/flow/saveOrUpdateTaskOperator', params)
}

const getTaskMessageSendConfig = (params) => {
  return request.post('/ipark-admin/flow/getTaskMessageSendConfig', params)
}
const getTaskMessageSendConfigEnd = (params) => {
  return request.post('/ipark-admin/flow/getTaskMessageSendConfigEnd', params)
}
const saveOrUpdateTaskMessageSendConfig = (params) => {
  return request.post('/ipark-admin/flow/saveOrUpdateTaskMessageSendConfig', params)
}
// 设置分支的超时
const timeoutConfig = (params) => {
  return request.post('/portal/flow/timeoutConfig', params)
}
// 查询分支的超时
const queryTimeoutConfig = (params) => {
  return request.post('/portal/flow/getTimeoutConfig', params)
}

// 设置分支的执行条件
const saveOrUpdateFlowGatewayExpression = (params) => {
  return request.post('/ipark-admin/flow/saveOrUpdateFlowGatewayExpression', params)
}

/** ***** 工作流流程配置 */
// 获取工作流具体流程
const getProcess = (params) => {
  return request.post('/ipark-admin/flow/getProcessByKey', params)
  // return request.post('/flow/getProcess', params)
}

// 流程监控
const getProcessMonitor = (params) => {
  return request.post('/portal/message/processMonitor', params)
}
// 记录查询
const getProcessRecord = (params) => {
  return request.post('/portal/message/processRecord', params)
}
// 导出用户列表1
const processRecordExport = (params) => {
  // params.mockApi = true
  return request.post('/portal/message/processRecord/export ', params, { responseType: 'blob' })
}

// 流程基础
const getConfigList = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/message/processMonitor/configList', params)
}
// 维护分组
const getGroupList = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/flow-record/list', params)
}
const addServiceGroup = (params) => {
  return request.post('/portal/flow-record/add-group', params)
}
const updateServiceGroup = (params) => {
  return request.post('/portal/flow-record/update-group', params)
}
const deleteServiceGroup = (params) => {
  return request.post('/portal/flow-record/delete-group', params)
}
const mofifyGroupRelation = (params) => {
  return request.post('/portal/flow-record/update-ref-group', params)
}
// 查询当前审批人
const queryCurrentApprove = (params) => {
  return request.post('/portal/message/processMonitor/queryCurrentApprove', params)
}

// 更新审批人
const updateCurrentApprove = (params) => {
  return request.post('/portal/message/processMonitor/updateCurrentApprove', params)
}

const queryAllManager = (params) => {
  return request.post('/portal/park/user/findParkUsers', params)
}
// 获取类型选项
const getSelectList = (params) => {
  return request.post('/portal/message/processMonitor/serviceType', params)
}
// 流程统计
const statisticsInfo = (params) => {
  return request.post('/portal/statisticsInfo/info', params)
}
//  申请量最多的业务流程TOP5 ：(使用)
const applyTrend = (params) => {
  return request.post('/portal/statisticsInfo/applyFlowTOP5', params)
}
// 业务最多的处理人TOP5
const nodeHandlerTOP5 = (params) => {
  return request.post('/portal/statisticsInfo/nodeHandlerTOP5', params)
}
// 按月展示当年度的申请趋势 ：
const ApplyTrendVO = (params) => {
  return request.post('/portal/statisticsInfo/applyTrend', params)
}
//  平均耗时最长的业务流程TOP5
const applyTimeTOP5 = (params) => {
  return request.post('/portal/statisticsInfo/applyTimeTOP5', params)
}

/** 网格化管理 */
// 获取网格化处理方式
const getLatitudeMode = (params) => {
  return request.post('/ipark-admin/meshing/latitude/getLatitudeMode', params)
}
// 修改网格化处理方式
const addLatitudeMode = (params) => {
  return request.post('/ipark-admin/meshing/latitude/addLatitudeMode', params)
}
// 获取部门人
const getParkUsersByNotInRoleId = (params) => {
  return request.post('/portal/department/departmentStaffBook', params)
}
// 新增网格维度
const addLatitude = (params) => {
  return request.post('/ipark-admin/meshing/latitude/addLatitude', params)
}
// 网格维度
const latitudeList = (params) => {
  return request.post('/ipark-admin/meshing/latitude/latitudeList', params)
}
// 网格维度排序
const updatePriority = (params) => {
  return request.post('/ipark-admin/meshing/latitude/updatePriority', params)
}
// 网格维度范围详情
const meshingRangeList = (params) => {
  return request.post('/ipark-admin/meshing/range/meshingRangeList', params)
}
// 新增/编辑网格划分维度
const addOrUpdateMeshingRange = (params) => {
  return request.post('/ipark-admin/meshing/range/addOrUpdateMeshingRange', params)
}
// 删除网格
const deleteMeshingRange = (params) => {
  return request.post('/ipark-admin/meshing/range/deleteMeshingRange', params)
}
// 设置处理人
const setProcessHandler = (params) => {
  return request.post('/ipark-admin/meshing/processes/setProcessHandler', params)
}
// 获取处理人
const getProcessHandler = (params) => {
  return request.post('/ipark-admin/meshing/processes/getProcessHandler', params)
}
// 获取可配置网格的公司列表
const getParkCompanyDepartmentAndUserInfo = (params) => {
  return request.post('/portal/department/getParkCompanyDepartmentAndUserInfo', params)
}
// 查询流程开关
const getFlowAutoStatus = (params) => {
  return request.post('/ipark-admin/flow/getFlowAutoStatus', params)
}
// 开启流程自开审核开关
const addFlowRecordAuto = (params) => {
  return request.post('/ipark-admin/flow/addFlowRecordAuto', params)
}
// 关闭流程自动审核状态
const closeFlowAutoStatus = (params) => {
  return request.post('/ipark-admin/flow/closeFlowAutoStatus', params)
}
// 获取网格化类型
const getLatitudeTypeList = (params) => {
  return request.post('/ipark-admin/meshing/latitude/getLatitudeTypeList', params)
}
// 新增网格化类型
const addLatitudeType = (params) => {
  return request.post('/ipark-admin/meshing/latitude/addLatitudeType', params)
}
// 删除网格化类型
const deleteLatitudeTypeList = (params) => {
  return request.post('/ipark-admin/meshing/latitude/deleteLatitudeTypeList', params)
}

export default {
  getUserName,
  pageFlowRecord,
  getFlowRecord,
  addFlowRecord,
  updateFlowRecord,
  openFlowRecord,
  delFlowRecord,
  createProcess,
  getStatusList,
  getProcessByKey,
  getProductProcess,
  saveOrUpdateTaskUser,
  getRoleList,
  getTaskOperatorByCondition,
  saveOrUpdateTaskOperator,
  getTaskMessageSendConfig,
  saveOrUpdateTaskMessageSendConfig,
  saveOrUpdateFlowGatewayExpression,
  timeoutConfig,
  queryTimeoutConfig,
  getProcess,
  getProcessMonitor,
  getProcessRecord,
  processRecordExport,
  getConfigList,
  queryCurrentApprove,
  updateCurrentApprove,
  queryAllManager,
  getSelectList,
  statisticsInfo,
  applyTrend,
  nodeHandlerTOP5,
  ApplyTrendVO,
  applyTimeTOP5,
  getLatitudeMode,
  addLatitudeMode,
  getParkUsersByNotInRoleId,
  addLatitude,
  latitudeList,
  updatePriority,
  meshingRangeList,
  addOrUpdateMeshingRange,
  deleteMeshingRange,
  setProcessHandler,
  getProcessHandler,
  getGroupList,
  addServiceGroup,
  updateServiceGroup,
  deleteServiceGroup,
  mofifyGroupRelation,
  getParkCompanyDepartmentAndUserInfo,
  selectFeedbackTypeList,
  getFlowAutoStatus,
  addFlowRecordAuto,
  closeFlowAutoStatus,
  getLatitudeTypeList,
  addLatitudeType,
  deleteLatitudeTypeList,
  getTaskMessageSendConfigEnd
}



// WEBPACK FOOTER //
// ./src/area-common/api/activityService.js